<template>
  <!--
    Komponent wyświetlający filtr pasów ruchu jako tabelę z checkboxami.
    Pozwala użytkownikowi wybrać pojedyncze pasy.
    Klasę CSS 'step-X' można wykorzystać do dostosowania wyglądu w różnych krokach.
  -->
  <div class="lane-numbers ds-panel" :class="`step-${step}`">
    <!--
      Nagłówek panelu z przetłumaczoną nazwą 'PASY RUCHU'.
    -->
    <div class="ds-panel__head">
      <h3 class="ds-panel__title">{{ t('lanes').toUpperCase() }}</h3>
    </div>
    <!--
      Tabela prezentująca numery pasów i checkboxy do wyboru.
    -->
    <table class="lane-table">
      <thead>
        <tr>
          <!-- Nagłówki kolumn z numerami pasów -->
          <th
            v-for="(item, index) in store.laneNumbers"
            :key="'th-' + index"
          >
            {{ item }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <!-- Checkboxy dla każdego pasa -->
          <td
            v-for="(item, index) in store.laneNumbers"
            :key="'cb-' + index"
          >
            <input-checkbox
              :field-name="index"
              field-value=""
              :checkedCondition="isChecked(index)"
              @clicked="setFilter(index)"
            />
          </td>
        </tr>
      </tbody>
      <!--
        Zakomentowana alternatywna struktura tabeli dla testów.
      -->
      <!-- <thead>
        <tr>
          <th>1</th><th>2</th><th>3</th><th>4</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td v-for="(_, i) in 4" :key="i">
            <input-checkbox
              :field-name="i"
              field-value=""
              :checkedCondition="isChecked(i)"
              @clicked="setFilter(i)"
            />
          </td>
        </tr>
      </tbody> -->
    </table>
  </div>
</template>

<script>
import InputCheckbox from "../InputCheckbox.vue"; // Komponent checkbox

export default {
  name: "LaneNumbers", // Nazwa komponentu
  props: {
    store: { required: true }, // Pinia store z danymi filtrów
    step: { type: Number, default: 1 }, // Aktualny krok widoku (do stylowania)
  },
  components: { InputCheckbox },
  methods: {
    /**
     * Dodaje lub usuwa numer pasa w filtrach
     * @param {number} index - indeks wybranego pasa
     */
    setFilter(index) {
      this.store.addItem("LaneNumbers", index);
    },
    /**
     * Sprawdza, czy dany pas jest zaznaczony w filtrach
     * @param {number} id - indeks pasa
     * @returns {boolean}
     */
    isChecked(id) {
      return (
        this.store.filters.laneNumbers &&
        this.store.filters.laneNumbers.includes(
          this.store.laneNumbers[id]
        )
      );
    },
  },
};
</script>

<style scoped>
/* Panel „Pasy ruchu" — wąska kolumna z numerami pasów i wyborem. */
.lane-numbers {
  min-width: 0;
}

.lane-table {
  width: 100%;
  border-collapse: collapse;
  text-align: center;
  background-color: var(--surface-primary);
}

/* Metryka wiersza nagłówkowego musi być identyczna jak w sąsiednich panelach
   górnego rzędu („Miejsce pomiaru", „Kategorie pojazdów"): 8 px paddingu w pionie
   + `--font-size-sm` + linia 1 px. Tylko wtedy numery pasów leżą w jednej linii
   z nagłówkami tamtych tabel. Zmiana któregokolwiek z tych trzech składników
   rozjeżdża rząd. */
.lane-table thead th {
  padding: var(--spacing-sm) var(--spacing-2xs);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-bold);
  color: var(--text-primary);
  text-align: center;
  vertical-align: middle;
}

/* Panel ma się kończyć na linii dzielącej wiersze w sąsiednich panelach: pod
   pierwszą lokalizacją i pod wierszem checkboxów w kategoriach. Ta linia leży
   50 px poniżej nagłówka tabeli (`--location-row-height`), a ostatni piksel
   zabiera dolne obramowanie panelu — stąd 49, nie 50.

   Ten brakujący piksel przesunąłby też środek wiersza o pół piksela w górę,
   więc dokładamy go do górnego paddingu: kontrolka wraca na oś checkboxów
   z „Miejsca pomiaru" i „Kategorii pojazdów" (25 px od górnej krawędzi wiersza). */
.lane-table tbody td {
  padding: calc(var(--spacing-sm) + 1px) var(--spacing-2xs) var(--spacing-sm);
  height: 49px;
  font-size: var(--font-size-sm);
  text-align: center;
  vertical-align: middle;
}

/* Jak w „Kategoriach pojazdów": blokowa kontrolka jest centrowana pionowo przez
   komórkę, zamiast siadać na linii bazowej tekstu. */
td :deep(.container) {
  display: flex;
  margin: 0 auto;
}
</style>